// extracted by mini-css-extract-plugin
export default {"button":"Button_button__r1E9E","block":"Button_block__p+bqA","disabled":"Button_disabled__UhmCV","flashy":"Button_flashy__VTCNH","rounded":"Button_rounded__x7x9e"};